(() => {
  'use strict';
  if (window.__vfContentProtection || (window.Shopify && window.Shopify.designMode)) return;
  window.__vfContentProtection = true;

  const catalogFiles = ["Hero.jpg", "IMG_0399_09231409-07b3-4f29-ab6b-7c8f12a05486.jpg", "IMG_1108.jpg", "IMG_1166.jpg", "IMG_1167.jpg", "IMG_1167_b61a9936-2187-40f0-8bf8-0443ce8b4874.jpg", "IMG_1194_92b99ef4-5d8d-468c-8ad7-7dd3f8f4f422.jpg", "IMG_1194_f0fed277-c8cd-42e0-8960-40ae18c65cb3.jpg", "IMG_1205.jpg", "IMG_1560.jpg", "IMG_1560_889304ad-0d19-4f11-ac1b-1ed58f2a422e.jpg", "KDF-55_Filter.jpg", "Survery_Results_Cover_Plate.jpg", "VitalFlow_Classic_Silver_Original.webp", "VitalFlow_Matt_Black_Hero_on_Marble_9170f245-8472-4532-a881-379a320e28c4.jpg", "VitalFlow_Shower_Guide_Cover.jpg", "chrome_on_marble_4033c15f-f037-4207-9155-5e29ef2a3de9.jpg", "shower_pan_2.gif", "vitalflow-classic-silver-approved.png", "vitalflow-shower-guide-cover.jpg"];
  const imageScopes = [
    '.product__media', '.product-media-modal', 'media-gallery', '.thumbnail-slider',
    '.product-card-wrapper', '.card-wrapper.product-card-wrapper', '.cart-item__image-container',
    '.cart-notification-product', '.vf-floating-product-card', '[data-vf-floating-card]',
    '[data-vf-reviews]', '.vf-review-lightbox', '.pp-review', '#pp-reviews',
    '.vf-customer-results', '.jdgm-widget', '.jdgm-medals', '[data-vf-protect-images]',
    '.vf-lab__figure', '[data-vf-lab-source]'
  ].join(',');
  const selectionScopes = [
    '[data-vf-water-map]', '[data-vf-wr]', '.vf-fv',
    '.vf-summary-rating', '.vf-category-summary', '.vf-recommend-rate', '.vf-review-scores',
    '.vf-lab__table-wrap', '.vf-lab__figure', '[data-vf-protect-visual]'
  ].join(',');
  const watermarkScopes = [
    ['[data-vf-map-canvas]', 'overlay'],
    ['[data-map-detail]', 'footer'],
    ['[data-map-table]', 'footer'],
    ['.vf-wr__card', 'footer'],
    ['.vf-fv__grid', 'footer'],
    ['.vf-fv__rows', 'footer'],
    ['.vf-summary-rating', 'footer'],
    ['.vf-summary-details', 'footer'],
    ['.vf-review-scores', 'footer'],
    ['.vf-lab__table-wrap', 'footer'],
    ['.vf-lab__figure', 'footer'],
    ['[data-vf-protect-visual]', 'footer']
  ];
  const controls = 'input,textarea,select,[contenteditable="true"],[contenteditable=""],[role="textbox"]';
  const isProductPage = /\/products\//.test(location.pathname);
  const isReviewPage = /\/pages\/[^/]*reviews?(?:\/|$)/i.test(location.pathname);

  const fileName = (url) => {
    try { return decodeURIComponent(new URL(url, location.href).pathname.split('/').pop() || ''); }
    catch (_) { return ''; }
  };
  function catalogMatch(img) {
    const names = [fileName(img.currentSrc || img.src), fileName(img.getAttribute('data-src') || '')];
    return catalogFiles.some((known) => {
      const stem = known.replace(/\.[^.]+$/, '');
      return names.some((name) => name === known || name === stem || name.startsWith(stem + '_') || name.startsWith(stem + '.'));
    });
  }
  function shouldProtectImage(img) {
    if (!(img instanceof HTMLImageElement) || img.closest('[data-vf-protection-exempt]')) return false;
    if (img.closest(imageScopes)) return true;
    if ((isProductPage || isReviewPage) && img.closest('#MainContent,main')) return true;
    if (catalogMatch(img)) return true;
    return /showerhead|customer (?:before|after)|review photo/i.test(img.alt || '');
  }
  function protectImage(img) {
    if (!shouldProtectImage(img)) return;
    img.setAttribute('data-vf-protected-image', '');
    if (img.draggable) img.draggable = false;
  }
  function each(scope, selector, fn) {
    if (scope.nodeType === 1 && scope.matches(selector)) fn(scope);
    if (scope.querySelectorAll) scope.querySelectorAll(selector).forEach(fn);
  }
  function scan(scope) {
    each(scope, 'img', protectImage);
    each(scope, selectionScopes, (el) => {
      if (!el.closest('[data-vf-protection-exempt]')) el.classList.add('vf-selection-protected');
    });
    watermarkScopes.forEach(([selector, mode]) => each(scope, selector, (el) => {
      if (el.closest('[data-vf-protection-exempt]')) return;
      el.classList.add('vf-watermarked-visual');
      if (!el.hasAttribute('data-vf-watermark')) el.setAttribute('data-vf-watermark', mode);
    }));
  }
  const eventElement = (event) => {
    const target = event.target;
    return target instanceof Element ? target : target && target.parentElement;
  };
  function protectedImageAt(el) {
    const image = el && el.closest('img');
    if (image && shouldProtectImage(image)) { protectImage(image); return image; }
    return null;
  }
  function blockContext(event) {
    const el = eventElement(event);
    if (!el || el.closest('[data-vf-protection-exempt]') || el.closest(controls)) return;
    if (protectedImageAt(el) || el.closest('.vf-selection-protected,.vf-watermarked-visual')) event.preventDefault();
  }
  function blockDrag(event) {
    const el = eventElement(event);
    if (!el || el.closest('[data-vf-protection-exempt]') || el.closest(controls)) return;
    if (protectedImageAt(el)) event.preventDefault();
    else if (el.closest('.vf-watermarked-visual') && !el.closest('a,button')) event.preventDefault();
  }
  function blockSelection(event) {
    const el = eventElement(event);
    if (!el || el.closest('[data-vf-protection-exempt]') || el.closest(controls)) return;
    if (el.closest('.vf-selection-protected') || protectedImageAt(el)) event.preventDefault();
  }
  document.addEventListener('contextmenu', blockContext, true);
  document.addEventListener('dragstart', blockDrag, true);
  document.addEventListener('selectstart', blockSelection, true);
  scan(document);

  const pending = new Set();
  let scheduled = false;
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes') pending.add(mutation.target);
      else mutation.addedNodes.forEach((node) => { if (node.nodeType === 1) pending.add(node); });
    });
    if (!pending.size || scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      const roots = [...pending]; pending.clear();
      roots.forEach((root) => { if (root.isConnected) scan(root); });
    });
  });
  observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['src', 'srcset', 'alt'] });
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
})();
